<div
  class="card card-{{ type }} card-box bg-white rounded {{ customClass }}"
  role="alert"
  [attr.aria-label]="title"
>
  <div class="card-body">
    <div class="d-flex justify-content-space-around align-items-center">
      <div class="text-center d-flex ps-1 pe-1">
        <div
          class="notification-icon"
          aria-hidden="true"
        >
          <img src="{{ deployUrl }}/assets/images/notifications/{{ type }}_ico.svg" alt="Notification" />
        </div>
      </div>
      <div class="content-block d-flex justify-content-center flex-column ps-3 pe-3">
        <div class="notification-title text-{{ type }}" aria-live="polite" [innerHTML]="title"></div>
        <!-- Title-only callers would otherwise render an empty description div and its margin. -->
        @if (subTitle) {
          <div class="notification-description mt-1" aria-live="polite" [innerHTML]="subTitle"></div>
        }
      </div>
    </div>
  </div>
</div>
